// Google Analytics 4 integration with GDPR compliance
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Initialize Google Analytics
export const initGA = (measurementId: string) => {
  if (typeof window !== 'undefined' && !window.gtag) {
    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      page_title: 'Utvecklare Direkt - Ladda ner CV\'n här',
      page_location: window.location.href,
    });
  }
};

// Track page views
export const trackPageView = (page: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_title: page,
      page_location: window.location.href,
    });
  }
};

// Track events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track developer interactions
export const trackDeveloperInteraction = (action: string, developerId: string, developerName: string) => {
  trackEvent(action, 'Developer Interaction', `${developerName} (${developerId})`);
};

// Track filter usage
export const trackFilterUsage = (filterType: string, filterValue: string) => {
  trackEvent('filter_used', 'Filter', `${filterType}: ${filterValue}`);
};

// Track search usage
export const trackSearchUsage = (searchTerm: string) => {
  trackEvent('search_performed', 'Search', searchTerm);
};

// Track selection actions
export const trackSelectionAction = (action: string, developerCount: number) => {
  trackEvent(action, 'Selection', `Developers: ${developerCount}`);
};

// Track contact form submission
export const trackContactSubmission = (developerCount: number, totalCost: number) => {
  trackEvent('contact_submitted', 'Contact Form', `Developers: ${developerCount}, Cost: $${totalCost}`);
};

// Check if user has consented to analytics
export const hasAnalyticsConsent = (): boolean => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('analytics_consent') === 'true';
  }
  return false;
};

// Set analytics consent
export const setAnalyticsConsent = (consent: boolean) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('analytics_consent', consent.toString());
  }
};

// Initialize analytics with consent check
export const initializeAnalytics = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (measurementId && measurementId !== 'G-XXXXXXXXXX' && hasAnalyticsConsent()) {
    initGA(measurementId);
  }
}; 